import React from "react";
import Navbar from "../../components/navigation/web/Navbar";
import { TabUpload } from "../../components/Upload/TabUpload";
import { useTranslation } from "react-i18next";

const UploadFiles = () => {
	const { t } = useTranslation();
	return (
		<>
			<Navbar
				view={{
					title: t("upload.title"),
					component: (
						<>
							<TabUpload />
						</>
					),
				}}
				right={null}
			/>
		</>
	);
};

export { UploadFiles };
